import * as React from 'react';
import { withDropdownMenu } from 'ui';
import { SimpleFormValidationConfig, requiredValidation } from 'app/infrastructure/simple-form';
import { defaultSerializeMappings } from 'app/infrastructure/simple-form/serialize';
import { form } from '../constants';
import { ConsentType } from '../types';
import { SmsModal } from './sms-modal';
import { EditConsentProps } from './types';

import styles from './edit-sms-consent.scss';

interface EditSmsConsentState {
  isOpen: boolean;
}

export class EditSmsConsentComponent extends React.PureComponent<EditConsentProps, EditSmsConsentState> {
  constructor(props: EditConsentProps) {
    super(props);

    this.state = {
      isOpen: false
    };
  }

  private handleToggle = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  private onClose = () => {
    this.handleToggle();
    this.props.clearConsent();
    this.props.handleDropdownHide && this.props.handleDropdownHide();
  };

  private onDone = () => {
    const {
      id,
      saveSubscription,
      sharedState: { id: recipientId },
      serialize,
      validate,
      translation
    } = this.props;

    const serializedForm = serialize(defaultSerializeMappings);
    const verificationCode = String(serializedForm[form.sms.verificationCode]);
    const subscription = {
      id,
      recipientId: Number(recipientId),
      type: ConsentType.sms,
      ...(!!verificationCode && { verificationCode }),
      value: {
        name: String(serializedForm.token),
        token: String(serializedForm.token)
      }
    };

    const validationConfig: SimpleFormValidationConfig = [
      requiredValidation(form.sms.phoneNumber)
    ];

    id && id > 0 && validate(validationConfig,
      () => saveSubscription(id, subscription,
        () => {
          this.props.loadConsents();
          this.props.clearConsent();
        }), translation.validation_error);
  };

  public render() {
    const {
      fetchingLoadConsent,
      fetchingSaveSubscription
    } = this.props;

    return (<li className={styles.wrapper}>
      <button className="dropdown-item" onClick={this.handleToggle} disabled={fetchingLoadConsent}>
        {this.props.translation.edit}
      </button>
      {this.state.isOpen
        && <SmsModal
          fetching={fetchingLoadConsent || fetchingSaveSubscription}
          onDone={this.onDone}
          onClose={this.onClose}
          {...this.props} />}
    </li>);
  }
}

const component = withDropdownMenu(EditSmsConsentComponent);

export { component as EditSmsConsent };
